<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon material-school_bk.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">ブランド管理</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'home' }">戻る</router-link>
    </div>
    <div class="container">
      <!--tab-->
      <ul class="nav nav-tabs">
        <li class="nav-item" id="tabmenu">
          <a class="nav-link active tabitem">ブランド</a>
        </li>
      </ul>

      <form class="form-inline">
        <button type="button" class="btn-sm" @click="createNewBrand">
          新規登録
        </button>
      </form>

      <button type="button" class="btn btn-gray" @click="exportToExcel">
        エクスポート
      </button>
      <button type="button" class="btn btn-gray" @click="exportToPdf">プリント</button>
      <button type="button" class="btn btn-gray" @click="displayColumns">
        表示項目選択
      </button>
      <div class="form-group float-right">
        <label for="text1">検索:</label>
        <input type="text" id="searchform_small" class="form-control" v-model="filter" />
      </div>

      <form class="form-inline showall">
        <div class="form-sort align-items-center">
          <div class="item-count col-2 my-1">
            <label class="mr-sm-2 sr-only" for="inlineFormCustomSelectSmall">
              Preference
            </label>
            <select class="custom-select mr-sm-2" id="inlineFormCustomSelectSmall" v-model="perPage">
              <option :value="totalBrands" selected>全</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
              <option :value="150">150</option>
            </select>
            件表示
          </div>
        </div>
      </form>

      <div class="tab-content">
        <div id="table-1" class="tab-pane active">
          <div class="table-wrapper-scroll-y">
            <b-table
              ref="brand-table"
              :min-width="tableWidth"
              class="sticky-table table-auto-height"
              selectable
              responsive
              sticky-header
              :items="brand.brands"
              :fields="filteredHeaders"
              :filter="filter"
              :filterIncludedFields="searchableFields"
              :per-page="perPage"
              :current-page="currentPage"
              :refreshed="tableRefreshed()"
            >
              <template v-slot:head()="scope">
                <div class="text-nowrap">
                  <b>{{ scope.label }}</b>
                </div>
              </template>

              <template v-slot:head(selected)>
                <b-form-checkbox @input="toggleSelectAll" v-model="selectAll" />
              </template>

              <template v-slot:cell(selected)="row">
                <b-form-checkbox @input="selectRow($event, row.index)" v-model="row.rowSelected" />
              </template>

              <template v-slot:cell(name)="row">
                <router-link :to="{ name: 'brand-id-detail', params: { id: row.item.id } }">
                  {{ row.value }}
                </router-link>
              </template>

              <template v-slot:cell(frozenStatus)="row">
                <div class="b-table-column-background-white">
                  <router-link :to="{ name: 'brand-id-frozen', params: { id: row.item.id } }">
                    {{ frozenStatus(row.value) }}
                  </router-link>
                </div>
              </template>
            </b-table>
          </div>
          <div class="pagination-footer">
            <label> {{ totalBrands }} 件中 {{ baseIndex }} から {{ capIndex }} まで表示 </label>
            <div class="float-right">
              <button :disabled="!hasPreviousPage" type="button" class="btn btn-invisible" @click="goToPreviousPage">
                前
              </button>
              <label class="pagination-border text-center">{{ currentPage }}</label>
              <button :disabled="!hasNextPage" type="button" class="btn btn-invisible" @click="goToNextPage">
                次
              </button>
            </div>
          </div>
        </div>
      </div>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="OK"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header>表示する項目を選択してください</template>
        <template v-slot:body>
          <thead>
            <tr v-for="field in customHeaders" :key="field.key">
              <th scope="row">
                <div class="custom-control custom-checkbox">
                  <input type="checkbox" class="custom-control-input" :id="field.key" v-model="field.enable" />
                  <label class="custom-control-label" :for="field.key">
                    {{ field.label }}
                  </label>
                </div>
              </th>
            </tr>
          </thead>
        </template>
      </PopUpHolder>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import store from '@/store/index.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import EventBus from '@/helpers/EventBus.js';
import { sumObjectArrayByKey } from '@/utils/math_helpers.js';
import { updateTableHeight } from '@/helpers/table';
import { updateStickyColumnsAndMinWidth } from '@/helpers/sticky_table';
import { basicFrozenStatus, basicFieldPresent } from '@/presenters/fields';
import XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import { buildJapaneseFont } from '@/helpers/PdfCustomFont.js';

export default {
  components: {
    PopUpHolder,
  },
  data() {
    var fields = [
      {
        key: 'selected',
        sortable: false,
        hidable: false,
        enable: true,
        searchable: false,
        class: 'sticky-column left-sticky-column-1',
        thAttr: { width: 20 },
      },
      {
        key: 'corporation',
        label: '法人名',
        sortable: true,
        hidable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 200 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return basicFieldPresent(value, 'name');
        },
      },
      {
        key: 'uid',
        label: 'ブランドID',
        sortable: true,
        hidable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 200 },
      },
      {
        key: 'name',
        label: 'ブランド名',
        sortable: true,
        hidable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 200 },
      },
    ];
    if (this.$store.getters['role/hasAdminPrivilege']) {
      fields.push({
        key: 'frozenStatus',
        label: '処理',
        sortable: false,
        hidable: false,
        enable: true,
        searchable: false,
        class: 'sticky-column right-sticky-column-1',
        thAttr: { width: 150 },
      });
    }
    return {
      fields: fields,
      currentPage: 1,
      perPage: 50,
      selectAll: false,
      filter: null,
    };
  },
  mounted() {
    EventBus.$on('SESSION_RESTORED', this.eventHandler);
    updateTableHeight();

    // 登録・編集の入力情報を初期化
    this.clearEditingBrand();
    this.$store.dispatch('form/clearFormDataStored');
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    store.dispatch('brand/fetchBrands', {}).then(() => {
      next();
    });
  },
  beforeDestroy() {
    EventBus.$off('SESSION_RESTORED', this.eventHandler);
  },
  computed: {
    baseIndex() {
      return (this.currentPage - 1) * this.perPage + 1;
    },
    capIndex() {
      return Math.min(this.baseIndex + this.perPage - 1, this.totalBrands);
    },
    hasPreviousPage() {
      return this.currentPage > 1;
    },
    hasNextPage() {
      return this.totalBrands > this.currentPage * this.perPage;
    },
    customHeaders() {
      return this.fields.filter((field) => field.hidable == true);
    },
    filteredHeaders() {
      return this.fields.filter((field) => field.enable == true);
    },
    searchableFields() {
      var fields = this.fields.filter((field) => field.enable == true && field.searchable == true);
      return fields.map((field) => field.key);
    },
    tableWidth() {
      return sumObjectArrayByKey(this.filteredHeaders, 'thAttr', 'width') + 'px';
    },
    selectedFieldLabels() {
      const filteredFields = this.fields.filter(
        (field) => field.enable == true && field.label && field.key != 'frozenStatus'
      );
      return filteredFields.map((field) => field.label);
    },
    ...mapState(['brand']),
    ...mapGetters('brand', ['totalBrands', 'getExcelFormattedBrands']),
  },
  methods: {
    tableRefreshed() {
      this.$logger.debug('Table refreshed');
      updateStickyColumnsAndMinWidth({ leftColumns: 1, rightColumns: 1 });
    },

    displayColumns() {
      this.$logger.debug('Display Columns for Brands');
      this.$refs['popup_holder'].show();
    },
    createNewBrand() {
      this.$router.push({ name: 'brand-add' });
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
      updateTableHeight();
    },
    goToPreviousPage() {
      this.selectAll = false;
      this.currentPage--;
    },
    goToNextPage() {
      this.selectAll = false;
      this.currentPage++;
    },
    toggleSelectAll(checked) {
      if (checked) {
        this.$refs['brand-table'].selectAllRows();
      } else {
        this.$refs['brand-table'].clearSelected();
      }
    },
    selectRow(checked, index) {
      if (checked) {
        this.$refs['brand-table'].selectRow(index);
      } else {
        this.$refs['brand-table'].unselectRow(index);
      }
    },
    eventHandler(payload) {
      if (payload.hasAdminPrivilege && this.fields.filter((item) => item.key === 'frozenStatus').length == 0) {
        this.fields.push({
          key: 'frozenStatus',
          label: '処理',
          sortable: false,
          hidable: false,
          enable: true,
          searchable: false,
          class: 'sticky-column right-sticky-column-1',
          thAttr: { width: 150 },
        });
      }
    },
    frozenStatus(field) {
      return basicFrozenStatus(field);
    },
    exportToExcel() {
      this.$logger.debug('Export Brands to Excel');
      let data = this.getExcelFormattedBrands(this.selectedFieldLabels);
      var brandWS = XLSX.utils.json_to_sheet(data);
      var wb = XLSX.utils.book_new(); // make Workbook of Excel
      XLSX.utils.book_append_sheet(wb, brandWS, 'Brands'); // add Worksheet to Workbook
      XLSX.writeFile(wb, 'brands.xlsx');
    },
    createHeaders(keys, columnWidth) {
      return keys.map((key) => ({
        name: key,
        prompt: key,
        width: columnWidth,
        align: 'left',
        padding: 0,
      }));
    },
    exportToPdf() {
      this.$logger.debug('Print Brands to PDF');
      let doc = new jsPDF({ orientation: 'l', format: 'a4' });
      buildJapaneseFont(doc);
      let data = this.getExcelFormattedBrands(this.selectedFieldLabels);
      const pdfPageWidth = doc.internal.pageSize.getWidth();
      const paddingWidth = 4;
      let columnWidth = (pdfPageWidth - paddingWidth * 2) / this.selectedFieldLabels.length;
      doc.table(paddingWidth, 4, data, this.createHeaders(this.selectedFieldLabels, columnWidth));
      doc.autoPrint();
      if (data.length > 150) {
        this.$logger.debug('Data too big, can only save');
        doc.save('brands.pdf', { returnPromise: true }).then(() => {
          this.$logger.debug('PDF saved successfully');
        });
      } else {
        this.$logger.debug('Data OK, Print from new window');
        doc.output('dataurlnewwindow', { filename: 'brands.pdf' });
      }
    },
    ...mapActions('brand', ['clearEditingBrand']),
  },
};
</script>

<style scoped>
.btn-sm {
  margin-left: 0px;
}
.btn-gray {
  margin-bottom: 5px;
}
.item-count {
  padding: 0;
  font-size: 10px;
}
.custom-control-label {
  font-weight: normal;
}
.pagination-footer {
  margin-top: 20px;
}
</style>
